export const STORE_KEY = '$_prepare_doc';
export const SET_LIST_DOCS = 'SET_LIST_DOCS';
export const SET_PARAMS_SEARCH = 'SET_PARAMS_SEARCH';
export const SET_QUESTION_WORK = 'SET_QUESTION_WORK';
export const SET_PRAM_EXAM = 'SET_PRAM_EXAM';
export const GET_BOOK = 'GET_BOOK';
export const SET_BOOKID = 'SET_BOOKID';
export const SET_QUESTION = 'SET_QUESTION';
export const SET_SLIDES_MAIN = 'SET_SLIDES_MAIN';
export const SET_SLIDES_IMG_MAIN = 'SET_SLIDES_IMG_MAIN';
export const SET_OBJ_ACTIVITY_SLIDE = 'SET_OBJ_ACTIVITY_SLIDE';
export const SET_SLIDE_CURR = 'SET_SLIDE_CURR';
export const SET_INDEX_SLIDE_VISIBLE = 'SET_INDEX_SLIDE_VISIBLE';
export const SET_CLASSES = 'SET_CLASSES';
export const SET_LINK_VIDEO_AUDIO = 'SET_LINK_VIDEO_AUDIO';
export const SET_DATA_MEDIA_VIEWER = 'SET_DATA_MEDIA_VIEWER';
export const SET_SLIDESHOW_VISIBLE = 'SET_SLIDESHOW_VISIBLE';
export const SET_PREVIEW_MEDIA_VISIBLE_INDEX = 'SET_PREVIEW_MEDIA_VISIBLE_INDEX';
export const SET_PARAM_FILTER_MEDIA_LIST = 'SET_PARAM_FILTER_MEDIA_LIST';
export const SET_SCALE_SLIDE = 'SET_SCALE_SLIDE';
export const SET_TYPE_QUESTION = 'SET_TYPE_QUESTION';
export const SET_VISIBLE_MODAL_FILE_UPLOADED = 'SET_VISIBLE_MODAL_FILE_UPLOADED';
export const SET_KEY_SIDEBAR_VISIBLE = 'SET_KEY_SIDEBAR_VISIBLE';

export const KEY_TXT = 'text'
export const KEY_SHAPE = 'shape'
export const KEY_PICTURE = 'image'
export const KEY_VIDEO = 'video'
export const KEY_AUDIO = 'audio'
export const KEY_SLIDE = 'slide'
export const MEDIA_TYPE_IMG = 9
export const MEDIA_TYPE_VIDEO = 3
export const MEDIA_TYPE_AUDIO = 10
export const MEDIA_TYPE_PP = 2
export const FILE_TYPE_UPLOADED_IMG = 1
export const FILE_TYPE_UPLOADED_VIDEO = 2
export const FILE_TYPE_UPLOADED_AUDIO = 3
export const BASE_64_DEFINE = 'data:image/png;base64,'
// Exam:
export const SET_EXAM_INFO = 'SET_EXAM_INFO'
export const SET_QUESTION_LIST = 'SET_QUESTION_LIST'
export const SET_QUESTION_DETAIL = 'SET_QUESTION_DETAIL'
export const SET_INDEX_QUESTION_WORKING = 'SET_INDEX_QUESTION_WORKING'
export const SET_CLASSES_EXAM = 'SET_CLASSES_EXAM'
export const SET_SUBJECTS_EXAM = 'SET_SUBJECTS_EXAM'
export const SET_PARAMS_GET_DATA_QUESTION_SAMPLE = 'SET_PARAMS_GET_DATA_QUESTION_SAMPLE'
export const SET_BOOKID_FILTER_QUESTION_SAMPLE = 'SET_BOOKID_FILTER_QUESTION_SAMPLE'
export const SET_BOOKINDEXID_FILTER_QUESTION_SAMPLE = 'SET_BOOKINDEXID_FILTER_QUESTION_SAMPLE'
export const SET_QUESTIONS_SAMPLE = 'SET_QUESTIONS_SAMPLE'
export const SET_QUESTION_CHOOSED = 'SET_QUESTION_CHOOSED'
export const SET_QUESTION_ID_CHOOSED = 'SET_QUESTION_ID_CHOOSED'
export const SET_CHAPTER_ID_QUESTIONS = 'SET_CHAPTER_ID_QUESTIONS'
export const SET_PARAMS_SEARCH_QUESTION_CHAPTER = 'SET_PARAMS_SEARCH_QUESTION_CHAPTER'
export const CONTENT_EDITOR_DEFAULT = '<p><br></p>'
export const SET_PARAMS_SEARCH_QUESTION_EXAM = 'SET_PARAMS_SEARCH_QUESTION_EXAM'
